module.exports = __webpack_public_path__ + "img/logo-vietnamobile.4db351da.png";